export default __webpack_public_path__ + "static/DEIPage-pattern-medium-whale-tail-3dcd3bedba3758c629c6f86d9142d529.png";